import { useLocation } from 'react-router-dom';
import getQueryParamsFromLocation from '../../lib/utils/getQueryParamsFromLocation';

export default function useQueryParam(key) {
  const location = useLocation();
  const params = getQueryParamsFromLocation(location);
  return params[key];
}
